import { IMapState } from '../types';

export function selectIsRulerEnabled(state: IMapState): boolean {
  return state.map.isRulerEnabled;
}
